import styled from 'styled-components';

export const Wrapper = styled.div<{ $singleStar?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--t-brand-fg-color);
`;

export const StarGroupWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TextInteractiveWrapper = styled.div`
  display: flex;
  align-items: center;
`;